import React from "react";
import styled from "styled-components";

const Wrap = styled.div``;

const Content = () => {
  return (
    <>
      <Wrap>
        <h2>About Us</h2>
        <p>
        At Your Path Therapy you are the heart of everything we do. We are committed to helping you and/or your loved ones overcome anxiety, heal from depression, gaining tools for ADHD, and reclaim a fulfilling life through personalized, evidence-based therapy.
        </p>
        <p>
        Our highly trained therapists offer specialized care for adults, teens, and children, bringing deep expertise in treating anxiety, depression, ADHD, trauma, and relationship challenges. At Your Path Therapy, every clinician is committed to creating a supportive, judgment-free environment where you and your family can feel safe, understood, and empowered. Whether seeking help for yourself or your child, you’ll work with a therapist who combines evidence-based approaches with genuine compassion — guiding you toward meaningful and lasting change.
        </p>
        <p>
        Every therapy session at Your Path Therapy is designed to address your unique needs and guide you toward lasting transformation. We focus on healing the mind, body, and spirit through proven therapeutic techniques and heartfelt care. 
        </p>
        <p>
        Partnering with Your Path Therapy connects you and your family to trusted mental health experts who help adults, teens, and children overcome challenges, build resilience, and discover lasting inner peace.
        </p>

        <a
          href="https://g.co/kgs/53fZXPF"
          target="_blank"
          rel="noopener noreferrer"
        >
          Visit our Office
        </a> 

        <br />
        <br />
      </Wrap>
    </>
  );
};

export default Content;
